import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { SnCamera } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';

@Component({
  selector: 'fs-cameras-resource',
  templateUrl: './cameras-resource.component.html',
  styleUrls: ['./cameras-resource.component.scss'],
})
export class CamerasResourceComponent implements OnInit, OnDestroy {
  @Input() public resources: any[];

  @Input() public removable: boolean;

  @Output() public readonly loadedCameras = new EventEmitter();

  @Input()
  public cameras: SnCamera[];

  public isLoading: boolean = false;

  private readonly _destroy$ = new Subject();

  constructor(private readonly _camerasAPI: SnCamerasAPI) {}

  public ngOnInit(): void {
    this._loadCameras();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _loadCameras(): void {
    if (!this.resources[0]?.id_In?.length) {
      return;
    }
    this.isLoading = true;
    this._camerasAPI
      .getCameraList({
        id__in: this.resources[0].id_In.join(','),
        pageSize: 'all',
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (res) => {
          this.cameras = res.results;
          this.loadedCameras.next(this.cameras);
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }
}
